import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import QRCode from 'qrcode'
import { FRONT_BASE_URL } from 'src/config/Request'
import { wtGetDateMonthYearFormat } from 'src/helpers/commons/moment'
export const EmployeeForm = (pdfData) => {
  const doc = new jsPDF()

  const pageWidth = doc.internal.pageSize.width
  const logo = 'assets/wil-icon.png'
  const profilePicture = 'assets/profile_image4.png'

  let yPositionIndex = 73

  const qrCodeTextCover = FRONT_BASE_URL + 'employee-profile?id=1' + pdfData.id
  QRCode.toDataURL(qrCodeTextCover, { width: 50 }, (err, url) => {
    if (err) {
      console.error(err)
    } else {
      // Adjust yPosition after the table
      doc.addImage(url, 'PNG', 90, 185, 37, 37)
    }
  })

  doc.setFont('helvetica', 'bold')
  doc.setFontSize(18)
  doc.setTextColor('black')

  const text0 = 'WAHINDUSTRIESLIMITED'
  const normalText = 'INDUSTRIES'
  const textWidth =
    (doc.getStringUnitWidth(text0) * doc.internal.getFontSize()) / doc.internal.scaleFactor

  const boldTextWidth =
    (doc.getStringUnitWidth(normalText) * doc.internal.getFontSize()) / doc.internal.scaleFactor

  const textX = pageWidth - 94 - textWidth / 2
  const textY = 26

  doc.text('WAH', textX, textY, { align: 'center' })

  doc.setFont('helvetica', 'normal')
  doc.text('INDUSTRIES', 103.5, textY, { align: 'center' })
  doc.setFont('helvetica', 'bold')
  doc.text('LIMITED', 135.5, textY, { align: 'center' })

  doc.setFontSize(12)

  doc.setFont('helvetica', 'bold')
  doc.setTextColor('black')
  doc.text('(HR Department)', pageWidth - 100, 31, { align: 'center' })

  function drawLine(x1, y1, x2, y2) {
    doc.setLineWidth(0.5)
    doc.setDrawColor(0)
    doc.line(x1, y1, x2, y2)
  }

  const textWidth1 =
    (doc.getStringUnitWidth('(HR Department)') * doc.internal.getFontSize()) /
    doc.internal.scaleFactor
  const textX1 = pageWidth - 100 - textWidth1 / 2
  const textY1 = 27
  const lineHeight1 = 5

  drawLine(textX1, textY1 + lineHeight1, textX1 + textWidth1, textY1 + lineHeight1)

  doc.setFontSize(11.5)
  doc.setFont('helvetica', 'normal')
  doc.text(`To,`, 17, 40, { align: 'left' })
  doc.setFont('helvetica', 'bold')
  doc.text(`${pdfData.full_name}`, 17, 44, { align: 'left' })
  doc.setFont('helvetica', 'normal')
  doc.text(`${pdfData.designation.name}`, 17, 48, { align: 'left' })
  doc.text(`${pdfData.department.name} Department`, 17, 52, { align: 'left' })
  doc.text(`WIL HQ`, 17, 56, { align: 'left' })

  const text = 'DIGITALIZATION OF THE HR RECORD'

  doc.setFontSize(11.5)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor('black')

  doc.text('Subject:', 17, 70)
  doc.setFont('helvetica', 'bold')
  doc.text(text, 35, 70)

  const textWidth2 = doc.getTextWidth(text)
  const textX2 = 35
  const textY2 = 70

  function drawLine(x1, y1, x2, y2) {
    doc.setLineWidth(0.5)
    doc.setDrawColor(0)
    doc.line(x1, y1, x2, y2)
  }

  const lineHeight2 = 0.5
  drawLine(textX2, textY2 + lineHeight2, textX2 + textWidth2, textY2 + lineHeight2)

  const TwoTable = [
    [
      {
        content:
          '       It is intimated that WIL HR Department is in the process of digitalization. In order to successfully proceed to update employees’ record, a form containing employee data has been generated through ERP on the basis of available records in HR. You are requested to:-',
        styles: { halign: 'justify', fontSize: 11.5 },
      },
    ],
    [
      {
        content: '\t\ta)  Validate the information in the form.',
        styles: { halign: 'left', fontSize: 11.5 },
      },
    ],
    [
      {
        content: '\t\tb)  Complete the missing data.',
        styles: { halign: 'left', fontSize: 11.5 },
      },
    ],
    [
      {
        content: '\t\tc)  Provide all relevant documents.',
        styles: { halign: 'left', fontSize: 11.5 },
      },
    ],
    [
      {
        content: '',
      },
    ],
    [
      {
        content: '2.\t It is requested to provide the same on or before 15th Jan 2024.',
        styles: { halign: 'left', fontSize: 11.5 },
      },
    ],
  ]
  const text2 = `Letter No: HR/${pdfData.id}/ Dated: ` + moment().format('DD MMMM YYYY')

  doc.setFont('helvetica', 'bold')
  doc.setFontSize(11.5)
  doc.setTextColor('black')
  doc.text(text2, 110, 160, { align: 'center' })

  const textWidth3 = doc.getTextWidth(text2)
  const textX3 = 71
  const textY3 = 155.5

  function drawLine(x1, y1, x2, y2) {
    doc.setLineWidth(0.5)
    doc.setDrawColor(0)
    doc.line(x1, y1, x2, y2)
  }

  drawLine(textX3, textY3 + 5, textX3 + textWidth3, textY3 + 5)

  const ThreeTable = [
    [
      {
        content: 'Cc: -',
        styles: { halign: 'left', fontSize: 11.5 },
      },
    ],
    [
      {
        content: 'a.\t Employee Office File\t\t}\t\tFor record, please.',
        styles: { halign: 'left', fontSize: 11.5 },
      },
    ],
  ]
  doc.setFontSize(10)
  doc.setFont('helvetica', 'italic')
  const text3 = 'This is a system-generated letter hence requires no signature or stamp'

  doc.text(text3, 110, 230, { align: 'center' })

  const textWidth4 = doc.getTextWidth(text3)
  const textX4 = 55
  const textY4 = 225.5

  function drawLine(x1, y1, x2, y2) {
    doc.setLineWidth(0.5)
    doc.setDrawColor(0)
    doc.line(x1, y1, x2, y2)
  }

  drawLine(textX4, textY4 + 5, textX4 + textWidth4, textY4 + 5)

  // doc.autoTable({
  //   startY: yPositionIndex,
  //   margin: { top: 40 }, // Header rows for first table
  //   body: OneTable, // Body rows for first table
  //   theme: 'plain',
  //   tableLineColor: '#ffffff',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto',
  //   styles: {
  //     lineColor: '#ffffff',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },

  // })
  // const gapBetweenTable12 = 14
  // const startYForTable2 = doc.autoTable.previous.finalY + gapBetweenTable12
  doc.autoTable({
    startY: yPositionIndex,
    margin: { top: 40 },
    body: TwoTable, // Body rows for second table
    theme: 'plain',
    tableLineColor: '#ffffff',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    styles: {
      lineColor: '#ffffff',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
  })

  const gapBetweenTable2333 = 30
  const startYForTable3333 = doc.autoTable.previous.finalY + gapBetweenTable2333
  doc.autoTable({
    startY: startYForTable3333,
    margin: { top: 40 },
    body: ThreeTable, // Body rows for second table
    theme: 'plain',
    tableLineColor: '#ffffff',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    styles: {
      lineColor: '#ffffff',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
  })
  doc.addPage()

  doc.setTextColor('#3c4b64')
  doc.setFont('Helvetica', 'bold') //Header middle branch logo

  doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
  doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

  doc.setFontSize(11)
  doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
  doc.setFontSize(11)
  doc.setFont('Helvetica')
  doc.text('INDUSTRIES', pageWidth - 171, 15)
  doc.text('LIMITED', pageWidth - 171, 20)
  doc.setFontSize(9)
  doc.text('www.wahindustries.com', pageWidth - 171, 25)

  let yPosition = 68
  doc.addImage(profilePicture, 'PNG', 146, 16, 40, 46)
  doc.setFontSize(12)
  const qrCodeText = FRONT_BASE_URL + 'employee-profile?id=1' + pdfData.id
  QRCode.toDataURL(qrCodeText, { width: 50 }, (err, url) => {
    if (err) {
      console.error(err)
    } else {
      // Adjust yPosition after the table
      doc.addImage(url, 'PNG', 14, 29, 37, 37)
    }
  })

  doc.setTextColor('#000000') // Set text color to black
  doc.setFont('Helvetica', 'bold')
  doc.setFontSize(14)
  const label = 'Personal File No: '
  const value = pdfData.personal_file_no ? pdfData.personal_file_no : ''
  doc.text(label, 137, 10, { align: 'left' })
  doc.setTextColor('blue') // Set text color to blue
  doc.text(value, 178, 10, { align: 'left' })
  const lineY = 11 // Adjust the Y position for the line below the text
  doc.setDrawColor(0) // Set draw color to black
  doc.line(137, lineY, 205, lineY) // Draw a line below the text

  const BasicDetailsTable = [
    [
      {
        content: 'PERSONAL DETAILS',
        colSpan: 5,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'First Name:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: pdfData.first_name ? pdfData.first_name : '',
        styles: { cellWidth: 23, halign: 'left', color: [4, 113, 222] },
        colSpan: 2,
      },
      { content: 'Last Name:', styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' } },
      {
        content: pdfData.last_name ? pdfData.last_name : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      { content: 'Gender:', styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' } },
      {
        content: pdfData.gender ? pdfData.gender : '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'Date of Birth:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.date_of_birth ? wtGetDateMonthYearFormat(pdfData.date_of_birth) : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Religion:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: pdfData.religion_status ? pdfData.religion_status : '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      { content: 'Domicile:', styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' } },
      {
        content: pdfData.domicile ? pdfData.domicile : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'CNIC:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: pdfData.cnic ? pdfData.cnic : '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'CNIC Issue Date:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.cnic_issue_date ? wtGetDateMonthYearFormat(pdfData.cnic_issue_date) : '',
        styles: { cellWidth: 40, halign: 'left' },
      },
    ],
    [
      {
        content: 'CNIC Expiry Date:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: pdfData.cnic_expiry_date ? wtGetDateMonthYearFormat(pdfData.cnic_expiry_date) : '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'Blood Group:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.blood_group ? pdfData.blood_group : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Driving License:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: 'Yes',
        styles: { cellWidth: 25, halign: 'center' },
      },
      {
        content: 'No',
        styles: { cellWidth: 25, halign: 'center' },
      },
      {
        content: 'License No:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.driving_license ? pdfData.driving_license : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'License Issue Date:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: pdfData.driving_license_issue_date
          ? wtGetDateMonthYearFormat(pdfData.driving_license_issue_date)
          : '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'License Expiry Date:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.driving_license_expiry_date
          ? wtGetDateMonthYearFormat(pdfData.driving_license_expiry_date)
          : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Passport:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: 'Yes',
        styles: { cellWidth: 25, halign: 'center' },
      },
      {
        content: 'No',
        styles: { cellWidth: 25, halign: 'center' },
      },
      {
        content: 'Passport No:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.passport_no ? pdfData.passport_no : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Passport Issue Date:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: pdfData.passport_issue_date
          ? wtGetDateMonthYearFormat(pdfData.passport_issue_date)
          : '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'Passport Expiry Date:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.passport_expiry_date
          ? wtGetDateMonthYearFormat(pdfData.passport_expiry_date)
          : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
  ]
  const CompanyDetailsTable = [
    [
      {
        content: 'COMPANY DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Grade:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.grade ? pdfData.grade : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Department Name:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.department ? pdfData.department.name : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Designation:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.designation ? pdfData.designation.name : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Date of joining:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.date_of_joining ? wtGetDateMonthYearFormat(pdfData.date_of_joining) : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
  ]
  const FamilyParticularTable = [
    [
      {
        content: 'FAMILY PARTICULARS',
        colSpan: 5,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],

    [
      {
        content: 'Relationship',
        styles: { fontStyle: 'bold', halign: 'center' },
      },
      { content: 'Name', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'DOB', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'CNIC#', styles: { fontStyle: 'bold', halign: 'center' } },
      {
        content: 'Occupation',
        styles: { fontStyle: 'bold', halign: 'center' },
      },
    ],
  ]
  // const NextOfKinTable = [
  //   [
  //     {
  //       content: 'NEXT OF KIN',
  //       colSpan: 4,
  //       styles: { halign: 'center', fontStyle: 'bold' },
  //     },
  //   ],
  //   [
  //     {
  //       content: 'Full Name:',
  //       styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.name : '',
  //       styles: { cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: 'Relationship:',
  //       styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.relationship : '',
  //       styles: { cellWidth: 46, halign: 'left' },
  //     },
  //   ],
  //   [
  //     { content: 'CNIC:', styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' } },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.cnic : '',
  //       styles: { cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: 'Mobile no:',
  //       styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.mobile_no : '',
  //       styles: { cellWidth: 46, halign: 'left' },
  //     },
  //   ],
  //   [
  //     {
  //       content: 'Home Phone:',
  //       styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.home_phone : '',
  //       styles: { cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: 'Permanent Address:',
  //       styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.permanent_address : '',
  //       styles: { cellWidth: 46, halign: 'left' },
  //     },
  //   ],
  // ]
  const ContactDetailsTable = [
    [
      {
        content: 'CONTACT DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Mobile no:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.mobile_no ? pdfData.mobile_no : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Phone no:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.phone_no ? pdfData.phone_no : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Permanent Address:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.permanent_address ? pdfData.permanent_address : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Resident Address:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.resident_address ? pdfData.resident_address : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Personal Email:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.personal_email ? pdfData.personal_email : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Official Email:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.official_email ? pdfData.official_email : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
  ]
  const OtherDetailsTable = [
    [
      {
        content: 'OTHER DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Marital Status:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.marital_status ? pdfData.marital_status : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Blood Group:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.blood_group ? pdfData.blood_group : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Religion:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.religion_status ? pdfData.religion_status : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Education Status:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:
          pdfData.education_status === 1
            ? 'Educated'
            : pdfData.education_status === 0
            ? 'Uneducated'
            : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Prior Experience:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.work_experience ? pdfData.work_experience : '',
        colSpan: 3,
        styles: { cellWidth: 45, halign: 'left' },
      },
    ],
  ]
  const EmergencyDetailsTable = [
    [
      {
        content: 'EMERGENCY CONTACT DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Name:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.emergency_contact_name ? pdfData.emergency_contact_name : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Relationship with Employee:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.relationship_with_employee ? pdfData.relationship_with_employee : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Phone no:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.emergency_phone_no ? pdfData.emergency_phone_no : '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Resident Address:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: pdfData.emergency_resident_address ? pdfData.emergency_resident_address : '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Email:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: pdfData.emergency_email ? pdfData.emergency_email : '',
        colSpan: 3,
        styles: { cellWidth: 45, halign: 'left' },
      },
    ],
  ]
  const EducationTable = [
    [
      {
        content: 'EDUCATION DETAILS',
        colSpan: 5,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Name Of School/University',
        styles: { fontStyle: 'bold', halign: 'center' },
      },
      { content: 'Degree', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Major Specialization', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Completion Year', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Grade/CGPA', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]
  const WorkExperienceTable = [
    [
      {
        content: 'WORK EXPERIENCE',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      { content: 'Name of Employer', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Last job title', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Employement Period', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Salary', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]
  const QuestionTable = [
    [
      {
        content: `Are you currently Unemployed? ${
          pdfData.currently_unemployed ? pdfData.currently_unemployed : ''
        }`,
        styles: { halign: 'left', fontStyle: 'plain' },
      },
    ],
    [
      {
        content: `May we contact your previous employer(s)? ${
          pdfData.previous_employer_contact ? pdfData.previous_employer_contact : ''
        }`,
        styles: { halign: 'left' },
      },
    ],
  ]
  const ReferenceTable = [
    [
      {
        content: ' REFERENCES',
        colSpan: 6,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      { content: 'Name', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Organization', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Designation', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Relationship', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'E-mail Address', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Contact #', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]
  const QuestionTable2 = [
    [
      {
        content: `Are you under any service bond with your present employer? ${
          pdfData.service_bond ? pdfData.service_bond : ''
        }`,
        styles: { halign: 'left', fontStyle: 'plain' },
      },
    ],
    [
      {
        content: `Are you a reservist in the armed forces? ${
          pdfData.armed_force ? pdfData.armed_force : ''
        }`,
        styles: { halign: 'left' },
      },
    ],
    [
      {
        content: `Have you suffered from any illness disability during last 5 years? ${
          pdfData.disability ? pdfData.disability : ''
        }`,
        styles: { halign: 'left' },
      },
    ],
    [
      {
        content: `Are you affiliated with any political party? ${
          pdfData.political_party ? pdfData.political_party : ''
        }`,
        styles: { halign: 'left' },
      },
    ],
    [
      {
        content: `Have you ever been convicted for any criminal charge?  ${
          pdfData.criminal_charge ? pdfData.criminal_charge : ''
        }`,
        styles: { halign: 'left' },
      },
    ],
  ]
  const BankDetailTable = [
    [
      {
        content: 'BANK ACCOUNT DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Bank Name',
        styles: { fontStyle: 'bold', cellWidth: 45, align: 'center' },
      },
      // {
      //   content: '',
      //   styles: { cellWidth: 45, halign: 'left' },
      // },
      {
        content: 'Branch',
        styles: { fontStyle: 'bold', cellWidth: 46, align: 'center' },
      },
      // {
      //   content: '',
      //   styles: { cellWidth: 46, halign: 'left' },
      // },
      // ],
      // [
      {
        content: 'Account Title',
        styles: { fontStyle: 'bold', cellWidth: 45, align: 'center' },
      },
      // {
      //   content: '',
      //   styles: { cellWidth: 45, halign: 'left' },
      // },
      {
        content: 'Account #',
        styles: { fontStyle: 'bold', cellWidth: 46, align: 'center' },
      },
      // {
      //   content: '',
      //   styles: { cellWidth: 46, halign: 'left' },
      // },
    ],
  ]
  const RelativesEmployedTable = [
    [
      {
        content: 'Do you have any relatives employed in POF or WIL? ',
        colSpan: 4,
        styles: { halign: 'left', fontStyle: 'bold' },
      },
    ],
    [
      { content: 'Name', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Department', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Designation', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Relationship', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]
  const AffirmTable = [
    [
      {
        content: 'I do solemnly affirm that:',
        styles: { halign: 'left', fontStyle: 'bold' },
      },
    ],
    [
      {
        content:
          'The information presented in this Form is accurate and truthful to the best of my knowledge and belief. I further confirm that all the details provided in this form are correct and complete to the best of my understanding.',
        styles: { halign: 'justify' },
      },
    ],
    // [
    //   {
    //     content:
    //       '2. I have joined WAH Industries Limited with no liabilities to any of my previous employer/s on date mentioned below.',
    //     styles: { halign: 'left' },
    //   },
    // ],
    [
      {
        content: '',
      },
    ],
    [
      {
        content: '',
      },
    ],
    [
      {
        content:
          'Employee Signature ___________________________   Date ___________________________',
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
  ]
  doc.autoTable({
    startY: yPosition,
    head: BasicDetailsTable.slice(0, 1), // Header rows for first table
    body: BasicDetailsTable.slice(1), // Body rows for first table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenTable23 = 8
  const startYForTable3 = doc.autoTable.previous.finalY + gapBetweenTable23
  doc.autoTable({
    startY: startYForTable3,
    head: ContactDetailsTable.slice(0, 1), // Header rows for second table
    body: ContactDetailsTable.slice(1), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenTables = 8
  const startYForTable2 = doc.autoTable.previous.finalY + gapBetweenTables
  doc.autoTable({
    startY: startYForTable2,
    head: CompanyDetailsTable.slice(0, 1), // Header rows for second table
    body: CompanyDetailsTable.slice(1), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenfamilyTables = 8
  const startYForTable6 = doc.autoTable.previous.finalY + gapBetweenfamilyTables
  const FamilyParticularDetails = () => {
    let family_particular = []

    if (pdfData.family_particular.length) {
      pdfData.family_particular.map((item) =>
        family_particular.push([
          item.relationship,
          item.name,
          item.date_of_birth ? wtGetDateMonthYearFormat(item.date_of_birth) : '',
          item.cnic,
          item.occupation,
        ]),
      )

      for (let i = 0; i < 3; i++) {
        family_particular.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    } else {
      for (let i = 0; i < 7; i++) {
        family_particular.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    }

    family_particular.push([
      {
        content: 'Marital Status:',
        styles: { fontStyle: 'bold', halign: 'left' },
      },
      {
        content: pdfData.marital_status ? pdfData.marital_status : '',
        colSpan: 4,
        styles: { halign: 'left' },
      },
    ])

    return family_particular
  }
  doc.autoTable({
    startY: startYForTable6,
    margin: { top: 20 },
    head: FamilyParticularTable, // Header rows for second table
    body: FamilyParticularDetails(), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    columnStyles: {
      0: { columnWidth: 30 },
      1: { columnWidth: 40 },
      3: { columnWidth: 50 },
    },
    didDrawPage: function (data) {},
  })
  // const gapBetweennextofkinTables = 8
  // const startYForTable7 = doc.autoTable.previous.finalY + gapBetweennextofkinTables
  // doc.autoTable({
  //   startY: startYForTable7,
  //   margin: { top: 20 },
  //   head: NextOfKinTable.slice(0, 1), // Header rows for second table
  //   body: NextOfKinTable.slice(1), // Body rows for second table
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   headStyles: { fillColor: [217, 218, 219] },
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) {},
  // })
  // const gapBetweenTable34 = 12
  // const startYForTable4 = doc.autoTable.previous.finalY + gapBetweenTable34
  // doc.autoTable({
  //   startY: startYForTable4,
  //   margin: { top: 40 },
  //   head: OtherDetailsTable.slice(0, 1), // Header rows for second table
  //   body: OtherDetailsTable.slice(1), // Body rows for second table
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   headStyles: { fillColor: [217, 218, 219] },
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) { },
  // })
  const gapBetweenTable45 = 6
  const startYForTable5 = doc.autoTable.previous.finalY + gapBetweenTable45
  console.log(startYForTable5)
  doc.autoTable({
    startY: startYForTable5,
    margin: { top: 20 },
    head: EmergencyDetailsTable.slice(0, 1), // Header rows for second table
    body: EmergencyDetailsTable.slice(1), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenEducationTables = 6
  const startYForTable8 = doc.autoTable.previous.finalY + gapBetweenEducationTables
  const educationDetails = () => {
    let employee_education = []
    if (pdfData.education.length) {
      pdfData.education.map((item) =>
        employee_education.push([
          item.school_university,
          item.employee_degree.name,
          item.major_specialization,
          item.completion_year,
          item.grade_cgpa,
        ]),
      )

      for (let i = 0; i < 3; i++) {
        employee_education.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    } else {
      for (let i = 0; i < 7; i++) {
        employee_education.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    }

    return employee_education
  }
  doc.autoTable({
    startY: startYForTable8,
    margin: { top: 20 },
    head: EducationTable, // Header rows for second table
    body: educationDetails(), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenWorkTables = 6
  const startYForTable9 = doc.autoTable.previous.finalY + gapBetweenWorkTables
  const EmployeeExperienceDetails = () => {
    let employee_experience = []
    if (pdfData.employee_experience.length) {
      pdfData.employee_experience.map((item) =>
        employee_experience.push([
          item.employer_name,
          item.last_job_title,
          item.duration,
          item.last_salary,
        ]),
      )

      for (let i = 0; i < 3; i++) {
        employee_experience.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    } else {
      for (let i = 0; i < 7; i++) {
        employee_experience.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    }

    return employee_experience
  }
  doc.autoTable({
    startY: startYForTable9,
    margin: { top: 20 },
    head: WorkExperienceTable, // Header rows for second table
    body: EmployeeExperienceDetails(), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  // const gapBetweenQuestionTables = 6
  // const startYForTable10 = doc.autoTable.previous.finalY + gapBetweenQuestionTables
  // doc.autoTable({
  //   startY: startYForTable10,
  //   margin: { top: 40 },
  //   body: QuestionTable,
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) { },
  // })
  // const gapBetweenBankTables = 8
  // const startYForTable11 = doc.autoTable.previous.finalY + gapBetweenBankTables
  // doc.autoTable({
  //   startY: startYForTable11,
  //   margin: { top: 40 },
  //   head: BankDetailTable.slice(0, 1), // Header rows for second table
  //   body: BankDetailTable.slice(1), // Body rows for second table
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   headStyles: { fillColor: [217, 218, 219] },
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) { },
  // })
  // const gapBetweenReferenceTables = 8
  // const startYForTable12 = doc.autoTable.previous.finalY + gapBetweenReferenceTables
  // const ReferenceDetails = () => {
  //   let employee_references = []
  //   if (pdfData.employee_references.length) {
  //     pdfData.employee_references.map((item) =>
  //       employee_references.push([
  //         item.name,
  //         item.organization,
  //         item.designation,
  //         item.relationship,
  //         item.email,
  //         item.contact,
  //       ]),
  //     )
  //   } else {
  //     for (let i = 0; i < 3; i++) {
  //       employee_references.push([
  //         { content: '' },
  //         { content: '' },
  //         { content: '' },
  //         { content: '' },
  //         { content: '' },
  //         { content: '' },
  //       ])
  //     }
  //   }

  //   return employee_references
  // }
  // doc.autoTable({
  //   startY: startYForTable12,
  //   margin: { top: 40 },
  //   head: ReferenceTable, // Header rows for second table
  //   body: ReferenceDetails(), // Body rows for second table
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   headStyles: { fillColor: [217, 218, 219] },
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) { },
  // })
  const gapBetweenRelativesEmployedTables = 8
  const startYForTable13 = doc.autoTable.previous.finalY + gapBetweenRelativesEmployedTables
  const RelativeDetails = () => {
    let employed_relative = []
    if (pdfData.employed_relative.length) {
      pdfData.employed_relative.map((item) =>
        employed_relative.push([
          item.name,
          item.department.name,
          item.designation.name,
          item.relationship,
        ]),
      )
    } else {
      for (let i = 0; i < 2; i++) {
        employed_relative.push([{ content: '' }, { content: '' }, { content: '' }, { content: '' }])
      }
    }

    return employed_relative
  }
  doc.autoTable({
    startY: startYForTable13,
    margin: { top: 20 },
    head: RelativesEmployedTable, // Header rows for second table
    body: RelativeDetails(), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })

  const gapBetweenAffirmTables = 8
  const startYForTable15 = doc.autoTable.previous.finalY + gapBetweenAffirmTables
  doc.autoTable({
    startY: startYForTable15,
    margin: { top: 20 },
    body: AffirmTable, // Body rows for second table
    theme: 'plain',
    tableLineColor: '#ffffff',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    styles: {
      lineColor: '#ffffff',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const addLogoToAllPages = () => {
    const pageCount = doc.internal.getNumberOfPages()
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      const pageWidth = doc.internal.pageSize.width
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold') //Header middle branch logo

      doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
      doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

      doc.setFontSize(11)
      doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
      doc.setFontSize(11)
      doc.setFont('Helvetica')
      doc.text('INDUSTRIES', pageWidth - 171, 15)
      doc.text('LIMITED', pageWidth - 171, 20)
      doc.setFontSize(9)
      doc.text('www.wahindustries.com', pageWidth - 171, 25)
    }
  }
  // addLogoToAllPages()

  // const addFooter = (doc) => {
  //   const pageCount = doc.internal.getNumberOfPages()
  //   let startPage = 1;
  //   for (let i = 1; i <= pageCount; i++) {
  //     doc.setPage(i)
  //     doc.setTextColor('black')
  //     doc.setFontSize(9)

  //     const lineHeight = 286 // Adjust this value as needed
  //     const lineWidth = 182 // Adjust this value as needed
  //     const lineX = 14 // Adjust this value as needed
  //     const lineY = lineHeight
  //     doc.line(lineX, lineY, lineX + lineWidth, lineY)
  //     // doc.text(`Page ${startPage} / ${pageCount}`, 190, 270, { align: 'right' })
  //     // startPage++;
  //     // if (startPage > 3) {
  //     //   startPage = 1
  //     // }
  //   }
  // }

  // addFooter(doc)

  doc.save('EmployeeDetails.pdf')
}
